import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'joinIfArray',
  standalone: true,
})
export class JoinIfArrayPipe implements PipeTransform {
  transform(value: any, separator = ', '): string {
    if (Array.isArray(value)) {
      return value.join(separator);
    } else {
      return value;
    }
  }
}
